export const isDev = process.env.NODE_ENV === 'development';

const IP_ADDRESS = true ? 'localhost' : '192.168.0.197';
// The dev app opened through the Cloudflare tunnel (evals.greetai.co, app-local.greetai.co) reaches the local
// recorder through its own tunnel hostname, since localhost would mean the viewer's machine.
const viaTunnel = typeof window !== 'undefined' && !['localhost', '127.0.0.1'].includes(window.location.hostname);

export const WORKERS = (() => ({
  USERS_WORKER: isDev
    ? viaTunnel
      ? 'https://local-recorder.greetai.co'
      : `http://localhost:5400`
    : 'https://messaging.greetai.co',
}))();

/** The app served as the evals workspace (evals.greetai.co): its home is /evals. */
export const isEvalsHost = typeof window !== 'undefined' && window.location.hostname.startsWith('evals.');